import React, { useState, useRef, useEffect } from "react";
import { RootUrl } from "../../../redux/types";

const CategorySelector = ({
  categories,
  selectedCategory,
  onCategoryChange,
  isOnline,
  isAppOffline,
  isElectron,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const getCategoryImageUrl = (category) => {
    if (!category?.categoryImage) return null;
    if (!isOnline && !isAppOffline && isElectron) {
      return `file://C:/MealBill${category.categoryImage}`;
    }
    return `${RootUrl}/${category.categoryImage}`;
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (categoryName) => {
    onCategoryChange(categoryName);
    setIsOpen(false);
  };

  const getSelectedCategoryData = () => {
    if (selectedCategory === "all") {
      return { name: "All Categories", image: null, icon: "mdi-view-grid" };
    }
    const category = categories?.find(
      (cat) => cat.categoryName === selectedCategory
    );
    return category
      ? {
          name: category.categoryName,
          image: category.categoryImage,
          icon: "mdi-food",
        }
      : { name: "All Categories", image: null, icon: "mdi-view-grid" };
  };

  const selectedData = getSelectedCategoryData();

  return (
    <div className="category-dropdown-wrapper" ref={dropdownRef}>
      {/* Dropdown Toggle Button */}
      <div
        className="category-dropdown-toggle"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="d-flex align-items-center flex-grow-1">
          {/* Selected Category Image/Icon */}
          <div className="category-dropdown-image">
            {selectedData.image ? (
              <img
                src={getCategoryImageUrl({
                  categoryImage: selectedData.image,
                })}
                alt={selectedData.name}
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.nextSibling.style.display = "flex";
                }}
              />
            ) : null}
            <div
              className="category-dropdown-icon bg-primary"
              style={{
                display: selectedData.image ? "none" : "flex",
              }}
            >
              <i className={`mdi ${selectedData.icon} text-white`}></i>
            </div>
          </div>

          {/* Selected Category Name */}
          <span className="category-dropdown-text">{selectedData.name}</span>
        </div>

        {/* Dropdown Arrow */}
        <i
          className={`mdi mdi-chevron-down category-dropdown-arrow ${
            isOpen ? "open" : ""
          }`}
        ></i>
      </div>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="category-dropdown-menu">
          {/* All Categories Option */}
          <div
            className={`category-dropdown-item ${
              selectedCategory === "all" ? "active" : ""
            }`}
            onClick={() => handleSelect("all")}
          >
            <div className="category-dropdown-image">
              <div className="category-dropdown-icon bg-primary">
                <i className="mdi mdi-view-grid text-white"></i>
              </div>
            </div>
            <span className="category-dropdown-text">All Categories</span>
            {selectedCategory === "all" && (
              <i className="mdi mdi-check text-primary ml-auto"></i>
            )}
          </div>

          {/* Category Options */}
          {categories &&
            categories.length > 0 &&
            categories.map((category) => (
              <div
                key={category.id || category.categoryName}
                className={`category-dropdown-item ${
                  selectedCategory === category.categoryName ? "active" : ""
                }`}
                onClick={() => handleSelect(category.categoryName)}
              >
                <div className="category-dropdown-image">
                  {category.categoryImage ? (
                    <img
                      src={getCategoryImageUrl(category)}
                      alt={category.categoryName}
                      onError={(e) => {
                        e.target.style.display = "none";
                        e.target.nextSibling.style.display = "flex";
                      }}
                    />
                  ) : null}
                  <div
                    className="category-dropdown-icon bg-secondary"
                    style={{
                      display: category.categoryImage ? "none" : "flex",
                    }}
                  >
                    <i className="mdi mdi-food text-white"></i>
                  </div>
                </div>
                <span className="category-dropdown-text">
                  {category.categoryName}
                </span>
                {selectedCategory === category.categoryName && (
                  <i className="mdi mdi-check text-primary ml-auto"></i>
                )}
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default CategorySelector;

